/* unplugin-vue-components disabled */import script from "./CartItem.vue?vue&type=script&setup=true&lang=js"
export * from "./CartItem.vue?vue&type=script&setup=true&lang=js"

import "./CartItem.vue?vue&type=style&index=0&id=4b571b68&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b571b68"]])

export default __exports__